export default __webpack_public_path__ + "static/media/tech_scale2.dc1966fd.png";